<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    妈湾站<br>
站点介绍<br>
妈湾站位于深圳市南山区规划五号路，横穿规划梦海大道，延至规划四号路下方，车站周边规划以商业、办公、住宅为主。车站为地下站，地下一层为站厅层，地下二层为站台层，设置3个出入口，车站设有自动扶梯、垂梯、公共洗手间等便民设施。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:23	00:15	5号线	3分钟	5分25秒<br>
黄贝岭	06:19	23:06	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:26	00:15	5号线	4分钟	6分钟<br>
黄贝岭	06:24	23:06	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:26	01:15	5号线	4分钟	6分钟<br>
黄贝岭	06:24	00:06	5号线	4分钟	6分钟<br><br>

站点出口信息<br>
A出入口:<br>
八号路,振海路北侧(东)，妈湾一路北侧（南）,妈湾社区服务中心,前海湾花园<br><br>
C出入口:<br>
振海路南侧、兴海大道东侧（北）、 博世路西侧（南）、 怡海大道南侧（东），蛇口海关，海城街<br><br>
D出入口:<br>
兴海大道东侧（南），招商领玺花园<br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 前海湾花园<br>
M409、M157<br><br>
C出入口:<br>
公交站名： 前海湾花园南<br>
M157、M158<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


